<!--START: header-->
<landing-app-header></landing-app-header>
<!--END: header-->


<div class="hero-section wf-section">
  <div class="container">
    <div class="hero-grid">
      <div id="w-node-_9eebbefb-f971-35c6-dde0-5038eeef659c-01529649">
        <h1 data-w-id="2ed10de6-2495-8eef-7dda-117fa3821790" class="hero-title">Build and sell custom products online<br></h1>
        <div class="margin-40px">
          <p data-w-id="059c0b0c-a0ee-feb4-95c5-8c9c0684e254" class="sub-heading">Create Print On Demand products with ease using our Merchloop Software.</p>
        </div>
        <div class="margin-40px">
          <div data-w-id="43ba9c1e-4e56-504b-b766-2ea65d9cf3ac" class="button-flex">
            <a href="#" class="button sign-up w-button">Sign Up→</a>
            <div class="button-wrapper _15px _0px-top">
              <a [routerLink]="['/how-it-works']" class="button orange w-button">Why Merchloop?→</a>
            </div>
          </div>
        </div>
      </div>
      <div class="illustration"><img src="assets/img/createhomescreencircle.png" width="1094" data-w-id="399e8c32-6738-71ad-2624-e1b30882b726" sizes="(max-width: 479px) 100vw, (max-width: 991px) 72vw, 41vw" srcset="assets/img/createhomescreencircle-p-500.png 500w, assets/img/createhomescreencircle-p-800.png 800w, assets/img/createhomescreencircle.png 879w" alt=""></div>
    </div>
  </div><img src="assets/img/Green-GreyStroke.png" width="60" data-w-id="c94f95c5-2c19-4652-449f-4ecf1cc75ddb" alt="" class="scribble-2">
</div>
<div class="section bg-padding-top wf-section video-section">
  <div class="container">
    <div class="lightbox-wrapper">
      <a (click)="showVideo=!showVideo" data-w-id="1773fd31-dd51-aac7-5599-7e7783962954" class="lightbox-link w-inline-block w-lightbox">
        <img src="assets/img/play-filled.svg" width="25" alt="">
      </a>
      <div class="margin-40px">
        <img src="assets/img/scribbles-6.png" width="50" data-w-id="056f5a68-f594-ef10-7547-2e1486dcaf67" sizes="50px" srcset="assets/img/scribbles-6-p-500.png 500w, assets/img/scribbles-6-p-800.png 800w, assets/img/scribbles-6.png 902w" alt="" class="scribble-arrow">
        <h2 data-w-id="ae36a5cd-d205-a375-9f37-d6ef78019124" class="hero-title _50px">See How <span class="add-scribble-below">Merchloop</span> Works</h2>
        <div class="margin-15px">
          <p data-w-id="07f2d188-0f77-6fc0-b04c-7532349c8825" class="sub-heading">Watch this quick video to learn how.<br></p>
        </div>
      </div>
    </div>
    <div class="margin-block">
      <div class="author-quote">
        <div class="author-circle"></div>
        <div class="author-wrapper">
          <div class="content-inside">
            <div class="_80-percent-block">
              <img src="assets/img/logo-1.png" width="120" alt="">
              <div class="margin-40px">
                <p>“The Mastertheme team provides excellent support, listens to their users and continually works to improve their product”<br></p>
              </div>
              <div class="margin-20px">
                <h4>John Doe, Ideaa Strategy</h4>
              </div>
            </div>
          </div><img src="assets/img/shape.png" sizes="100vw" srcset="assets/img/shape-p-500.png 500w, assets/img/shape-p-800.png 800w, assets/img/shape-p-1080.png 1080w, assets/img/shape-p-1600.png 1600w, assets/img/shape-p-2000.png 2000w, assets/img/shape-p-2600.png 2600w, assets/img/shape-p-3200.png 3200w, assets/img/shape.png 4122w" alt="" class="shape">
        </div>
      </div>
    </div>
  </div>
</div>
<section class="section-3 wf-section">
  <h1 class="heading-8">Start selling online in minutes!</h1>
  <div class="container-4 w-container">
    <div class="content-block">
      <div class="steps-clone">
        <div class="step-block">
          <div class="img-block"><img src="assets/img/Merchloopbanneridea5.jpg" loading="lazy" sizes="100vw" srcset="assets/img/Merchloopbanneridea5-p-1080.jpeg 1080w, assets/img/Merchloopbanneridea5-p-1600.jpeg 1600w, assets/img/Merchloopbanneridea5-p-2000.jpeg 2000w, assets/img/Merchloopbanneridea5-p-2600.jpeg 2600w, assets/img/Merchloopbanneridea5.jpg 2880w" alt="" class="image-3"></div>
          <div class="dot"></div>
          <div class="content-wrap">
            <div class="step-content-block">
              <div class="step">
                <div class="text-block-2">
                  <div class="label">1.</div>
                  <div class="content">
                    <div class="heading-7">Build your product</div>
                    <p>Choose from one of our blank products and bring your design to life in minutes within our awesome designer.</p>
                  </div>
                </div>
              </div>
              <div class="bg-shadow"></div>
            </div>
          </div>
        </div>
        <div class="step-block">
          <div class="scoll-wrap">
            <div class="scroll-animate"></div>
            <div class="scroll-base"></div>
          </div>
          <div class="content-wrap">
            <div class="step-content-block">
              <div class="step">
                <div class="text-block-2">
                  <div class="label">02</div>
                  <div class="content">
                    <div class="heading-7">Set your profit</div>
                    <p>Set Your Profit / The product pricing you see includes all product costs and fulfillment direct to your customer. Never any hidden fees!</p>
                  </div>
                </div>
              </div>
              <div class="bg-shadow"></div>
            </div>
          </div>
          <div class="dot"></div>
          <div class="img-block"><img src="assets/img/Merchloopbanneridea5.jpg" loading="lazy" sizes="100vw" srcset="assets/img/Merchloopbanneridea5-p-1080.jpeg 1080w, assets/img/Merchloopbanneridea5-p-1600.jpeg 1600w, assets/img/Merchloopbanneridea5-p-2000.jpeg 2000w, assets/img/Merchloopbanneridea5-p-2600.jpeg 2600w, assets/img/Merchloopbanneridea5.jpg 2880w" alt="" class="image-4"></div>
        </div>
        <div class="step-block bottom">
          <div class="img-block"><img src="assets/img/Merchloopbanneridea5.jpg" loading="lazy" sizes="100vw" srcset="assets/img/Merchloopbanneridea5-p-1080.jpeg 1080w, assets/img/Merchloopbanneridea5-p-1600.jpeg 1600w, assets/img/Merchloopbanneridea5-p-2000.jpeg 2000w, assets/img/Merchloopbanneridea5-p-2600.jpeg 2600w, assets/img/Merchloopbanneridea5.jpg 2880w" alt="" class="image-5"></div>
          <div class="dot"></div>
          <div class="content-wrap">
            <div class="step-content-block">
              <div class="step">
                <div class="text-block-2">
                  <div class="label">03</div>
                  <div class="content">
                    <div class="heading-7">Publish to a store!</div>
                    <p>Whether you plan to use our store builder to sell your products or using Shopify, you can publish your fresh new product and start selling!</p>
                  </div>
                </div>
              </div>
              <div class="bg-shadow"></div>
            </div>
          </div>
          <div class="scoll-wrap">
            <div class="scroll-animate"></div>
            <div class="scroll-base"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div data-w-id="21e4c749-003e-df3e-b142-90fce87173c8" class="features-section wf-section">
  <h1 class="heading-9">What you can expect from Merchloop</h1>
  <div class="container">
    <div class="features-grid _50">
      <div id="w-node-_82113dd4-72b6-4070-242a-96702cfabafb-01529649" class="boxes-grid">
        <div class="features-content right-side">
          <img src="assets/img/icons8-view-quilt-512.png" width="50" alt="">
          <h3>Quality Products<br></h3>
          <p>We stand by our quality so much we guarantee 100% satisfaction.<br></p>
        </div>
        <div class="features-content left-side">
          <img src="assets/img/icons8-web-design-512.png" width="50" alt="">
          <h3>Extra Fast Ship Times<br></h3>
          <p>Products shipped within 3 business days!<br></p>
        </div>
        <div class="features-content right-side">
          <img src="assets/img/icons8-online-support-512.png" width="50" sizes="50px" srcset="assets/img/icons8-online-support-512-p-500.png 500w, assets/img/icons8-online-support-512.png 512w" alt="">
          <h3>Professional, World-Class Support<br></h3>
          <p>We love what we do &amp; who we do it for.<br></p>
        </div>
        <div class="features-content left-side">
          <img src="assets/img/icons8-view-quilt-512.png" width="50" alt="">
          <h3>Use it your way<br></h3>
          <p>We have ability to integrate into existing stores or use our free platform.<br></p>
        </div>
      </div>
      <div class="features-photo"></div>
    </div>
  </div><img src="assets/img/Redcirclefull.png" width="60" sizes="100vw" srcset="assets/img/Redcirclefull-p-500.png 500w, assets/img/Redcirclefull-p-800.png 800w, assets/img/Redcirclefull-p-1080.png 1080w, assets/img/Redcirclefull-p-1600.png 1600w, assets/img/Redcirclefull-p-2000.png 2000w, assets/img/Redcirclefull-p-2600.png 2600w, assets/img/Redcirclefull.png 3000w" alt="" class="scribble-3">
</div>
<!--<div class="section howitworks wf-section">
  <div class="container">
    <h1 class="heading-3">Who this is great for!</h1>
    <div class="illustrator-grid">
      <div class="illustration">
        <div style="padding-top:56.17021276595745%" class="w-video w-embed">
          <iframe class="embedly-embed" src="https://cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2FBKlnn0LQe-M%3Ffeature%3Doembed&display_name=YouTube&url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DBKlnn0LQe-M&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FBKlnn0LQe-M%2Fhqdefault.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=youtube" scrolling="no" title="YouTube embed" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>
        </div>
      </div>
      <div id="w-node-_91b689d6-dccb-ebfe-ffa0-73d41f783ca4-01529649" class="list-circle-wrapper">
        <div class="list-flex">
          <div class="list-item">
            <div class="number-text">1</div>
            <p><strong>Brands &amp; Bands. </strong>choose one of our blank products to put your design on.<br></p>
          </div>
          <div class="list-item">
            <div class="number-text">2</div>
            <p><strong>Build your store. </strong>Using our awesome store builder tool, get your store ready for the world using customizable components.<br></p>
          </div>
          <div class="list-item no-bottom-line">
            <div class="number-text">3</div>
            <p><strong>Get your ideas into the world. </strong>Now the moment you&#x27;ve been waiting for... People coming to your store to support your business, band, school or just a cool idea you had<br></p>
          </div>
        </div>
      </div>
    </div>
    <div class="margin-block">
      <div class="align-center">
        <h3 class="hero-title _50px">Meet the Merchloop Team</h3>
        <div class="margin-15px">
          <p class="sub-heading">Join our global team and enjoy the ride!<br></p>
        </div>
      </div>
      <div class="team-content">
        <div>
          <div class="team-image"></div>
          <h4>Kevin Oakley - President</h4>
          <div class="margin-15px">
            <p>&quot;As an designer, I love the technical challenges that come with a fast growing company.&quot;<br></p>
          </div>
        </div>
        <div>
          <div class="team-image _2"></div>
          <h4>Shane Snodgrass - CEO</h4>
          <div class="margin-15px">
            <p>&quot;As an designer, I love the technical challenges that come with a fast growing company.&quot;<br></p>
          </div>
        </div>
        <div>
          <div class="team-image _3"></div>
          <h4>Jessica Johnson - Director of Customer Exp</h4>
          <div class="margin-15px">
            <p>&quot;As an designer, I love the technical challenges that come with a fast growing company.&quot;<br></p>
          </div>
        </div>
      </div>
      <div class="line-divider"></div>
      <div class="container">
        <div class="logo-grid"><img src="assets/img/logo-3.png" width="150" alt=""><img src="assets/img/logo-2.png" width="140" alt=""><img src="assets/img/logo-6.png" width="140" alt=""><img src="assets/img/logo-5.png" width="140" sizes="100vw" srcset="assets/img/logo-5-p-500.png 500w, assets/img/logo-5.png 2160w" alt=""><img src="assets/img/logo-1.png" width="130" alt=""><img src="assets/img/logo-4.png" width="130" alt=""></div>
      </div>
    </div>
  </div><img src="assets/img/scribbles-2.png" width="140" data-w-id="d231c77e-6839-fee5-c24d-70d08997d5cc" sizes="100vw" srcset="assets/img/scribbles-2-p-500.png 500w, assets/img/scribbles-2-p-800.png 800w, assets/img/scribbles-2.png 1036w" alt="" class="scribble-1">
</div>-->
<div class="section storesection homepage wf-section">
  <div class="container">
    <div class="carers-grid">
      <div class="carers-photo photo-2">
        <img src="assets/img/scribbles-8.png" width="100" data-w-id="88436c20-479d-d732-d2d8-f20d0009274a" sizes="(max-width: 479px) 50px, 100px" srcset="assets/img/scribbles-8-p-500.png 500w, assets/img/scribbles-8-p-800.png 800w, assets/img/scribbles-8-p-1080.png 1080w, assets/img/scribbles-8-p-1600.png 1600w, assets/img/scribbles-8.png 2287w" alt="" class="scribble-6">
        <div class="flex-content">
          <div class="margin-20px">
            <h2 class="hero-title _50px color-white">Fundraising Stores<br></h2>
          </div>
          <div class="margin-20px">
            <p class="sub-heading color-white">Get the most out of your fundraising by using a made to order store where you can sell as much your cause needs with no up front costs. <strong><br></strong></p>
          </div>
        </div>
        <a (click)="openloginFormDialog()" class="button orange w-button">View Live Store→</a>
      </div>
      <div class="carers-block merch-store">
        <div class="flex-content">
          <div class="margin-20px">
            <h2 class="hero-title _50px color-white">Pop Up Merch Stores<br></h2>
          </div>
          <div class="margin-20px">
            <p class="sub-heading color-white">Your best work happens when tools stay out of the way.<strong><br></strong></p>
          </div>
        </div>
        <div class="margin-20px">
          <a (click)="openloginFormDialog()" class="button orange w-button">View Live Store→</a>
        </div>
      </div>
    </div>
    <div class="margin-50px">
      <div class="carers-grid">
        <div class="carers-block orange">
          <div class="flex-content">
            <div class="tag-text color">By mastertheme</div>
            <div class="margin-20px">
              <h2 class="hero-title _50px color-white">Small Business Stores<br></h2>
            </div>
            <div class="margin-20px">
              <p class="sub-heading color-white">For a simpel company store, check out this sample store to see what you can create for your small business.<strong><br></strong></p>
            </div>
          </div>
          <div class="margin-20px">
            <a (click)="openloginFormDialog()" class="button orange w-button">View Live Store→</a>
          </div>
        </div>
        <div class="carers-photo photo-3">
          <a href="#" data-w-id="88436c20-479d-d732-d2d8-f20d0009277c" class="lightbox-link orange w-inline-block w-lightbox">
            <img src="assets/img/play-filled.svg" width="25" alt="">
          </a>
        </div>
        <div class="carers-block orange">
          <div class="flex-content">
            <div class="tag-text color">By mastertheme</div>
            <div class="margin-20px">
              <h2 class="hero-title _50px color-white">School Stores<br></h2>
            </div>
            <div class="margin-20px">
              <p class="sub-heading color-white">This is a great sample store if you are looking to build a quick and simple store for you school club, booster club or athletic fundraiser.<strong><br></strong></p>
            </div>
          </div>
          <div class="margin-20px">
            <a (click)="openloginFormDialog()" class="button team-store w-button">View Live Store→</a>
          </div>
        </div>
        <div class="carers-block orange">
          <div class="flex-content">
            <div class="tag-text color">By mastertheme</div>
            <div class="margin-20px">
              <h2 class="hero-title _50px color-white">Shopify Merch store<br></h2>
            </div>
            <div class="margin-20px">
              <p class="sub-heading color-white">For more advanced and established clothing companies should look to integrate our Shopify App and now you will be able to sell your merch to order.<strong><br></strong></p>
            </div>
          </div>
          <div class="margin-20px">
            <a (click)="openloginFormDialog()" class="button team-store w-button">View Live Store→</a>
          </div>
        </div>
        <div class="carers-block orange">
          <div class="flex-content">
            <div class="tag-text color">By mastertheme</div>
            <div class="margin-20px">
              <h2 class="hero-title _50px color-white">Shopify Company store<br></h2>
            </div>
            <div class="margin-20px">
              <p class="sub-heading color-white">Companies with larger workforces and more products to distribute to their staff should contact us to build a Shopify store where we can integrate all our made to order products to reduce your up front and overall company apparel. <strong><br></strong></p>
            </div>
          </div>
          <div class="margin-20px">
            <a (click)="openloginFormDialog()" class="button team-store w-button">View Live Store→</a>
          </div>
        </div>
        <div class="carers-block orange">
          <div class="flex-content">
            <div class="tag-text color">By mastertheme</div>
            <div class="margin-20px">
              <h2 class="hero-title _50px color-white">Shopify Influencer store<br></h2>
            </div>
            <div class="margin-20px">
              <p class="sub-heading color-white">To help monetize your following, you should contact us about building a Shopify store where we can sell your merchandise made to order to maximize your speed to market and reduce your costs associated with building a merch line.<strong><br></strong></p>
            </div>
          </div>
          <div class="margin-20px">
            <a (click)="openloginFormDialog()" class="button team-store w-button">View Live Store→</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="section-2 wf-section">
  <div class="w-container">
    <div data-delay="4000" data-animation="slide" class="w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
      <div class="w-slider-mask">
        <div class="w-slide"></div>
        <div class="w-slide"></div>
      </div>
      <div class="w-slider-arrow-left">
        <div class="w-icon-slider-left"></div>
      </div>
      <div class="w-slider-arrow-right">
        <div class="w-icon-slider-right"></div>
      </div>
      <div class="w-slider-nav w-round"></div>
    </div>
  </div>
</div>
<div class="sample-store fundraising wf-section">
  <div class="w-layout-grid grid-3">
    <div class="storename">
      <h1>Fundraising Store</h1>
      <div>Merchloop has great fundraising components built in that allow you to maximize the amount you can put towards the causes that matter most to you.</div>
      <a (click)="openloginFormDialog()" class="button store w-button">View Store →</a>
    </div>
    <div id="w-node-_785141b2-54b3-2583-c387-9de73e291a28-01529649" class="storepicture _135"><img src="assets/img/Merchloopbanneridea5.jpg" loading="lazy" sizes="100vw" srcset="assets/img/Merchloopbanneridea5-p-1080.jpeg 1080w, assets/img/Merchloopbanneridea5-p-1600.jpeg 1600w, assets/img/Merchloopbanneridea5-p-2000.jpeg 2000w, assets/img/Merchloopbanneridea5-p-2600.jpeg 2600w, assets/img/Merchloopbanneridea5.jpg 2880w" alt=""></div>
  </div>
</div>
<div class="sample-store company-store wf-section">
  <div class="w-layout-grid grid-3">
    <div id="w-node-_79fc4e00-3957-667f-6adb-b74550e9e48a-01529649" class="storepicture"><img src="assets/img/Merchloopbanneridea5.jpg" loading="lazy" sizes="100vw" srcset="assets/img/Merchloopbanneridea5-p-1080.jpeg 1080w, assets/img/Merchloopbanneridea5-p-1600.jpeg 1600w, assets/img/Merchloopbanneridea5-p-2000.jpeg 2000w, assets/img/Merchloopbanneridea5-p-2600.jpeg 2600w, assets/img/Merchloopbanneridea5.jpg 2880w" alt=""></div>
    <div class="storename">
      <h1>Company Store</h1>
      <div>Merchloop has great fundraising components built in that allow you to maximize the amount you can put towards the causes that matter most to you.</div>
      <a (click)="openloginFormDialog()" class="button store w-button">View Store →</a>
    </div>
  </div>
</div>
<div class="sample-store merch wf-section">
  <div class="w-layout-grid grid-3">
    <div class="storename _135">
      <h1>Merch Store</h1>
      <div>Merchloop has great fundraising components built in that allow you to maximize the amount you can put towards the causes that matter most to you.</div>
      <a (click)="openloginFormDialog()" class="button store w-button">View Store →</a>
    </div>
    <div id="w-node-_2e766cb6-55ae-d2d5-8b84-3f7194ce8483-01529649" class="storepicture _135"><img src="assets/img/Merchloopbanneridea5.jpg" loading="lazy" sizes="100vw" srcset="assets/img/Merchloopbanneridea5-p-1080.jpeg 1080w, assets/img/Merchloopbanneridea5-p-1600.jpeg 1600w, assets/img/Merchloopbanneridea5-p-2000.jpeg 2000w, assets/img/Merchloopbanneridea5-p-2600.jpeg 2600w, assets/img/Merchloopbanneridea5.jpg 2880w" alt=""></div>
  </div>
</div>
<div class="sample-store school-store wf-section">
  <div class="w-layout-grid grid-3">
    <div id="w-node-f2655187-8c56-d8d3-e833-04e817d3d63c-01529649" class="storepicture"><img src="assets/img/Merchloopbanneridea5.jpg" loading="lazy" sizes="100vw" srcset="assets/img/Merchloopbanneridea5-p-1080.jpeg 1080w, assets/img/Merchloopbanneridea5-p-1600.jpeg 1600w, assets/img/Merchloopbanneridea5-p-2000.jpeg 2000w, assets/img/Merchloopbanneridea5-p-2600.jpeg 2600w, assets/img/Merchloopbanneridea5.jpg 2880w" alt=""></div>
    <div class="storename">
      <h1>School Store</h1>
      <div>Merchloop has great fundraising components built in that allow you to maximize the amount you can put towards the causes that matter most to you.</div>
      <a (click)="openloginFormDialog()" class="button store w-button">View Store →</a>
    </div>
  </div>
</div>
<!--<div class="get-started-section wf-section">
  <div class="container">
    <div class="align-center">
      <h3 class="hero-title _50px">Get Started</h3>
      <div class="margin-15px">
        <p class="sub-heading">No credit card or up front costs required!<br></p>
      </div>
    </div>
    <div class="subscribe-wrapper">
      <div class="w-form">
        <form name="email-form" data-name="Email Form" class="form">
          <input type="text" class="text-field w-node-_350a3e38-a2cd-938b-01ee-8c7deaa5b58e-01529649 w-input" maxlength="256" name="Name" data-name="Name" placeholder="Enter your name" id="Name" required="">
          <input type="email" class="text-field w-node-_9f2ea15e-bb26-0f78-2e28-b157c8e583c3-01529649 w-input" maxlength="256" name="Email" data-name="Email" placeholder="Enter your email" id="Email" required="">
          <input type="submit" value="Get Started →" data-wait="Please wait..." class="button subscribe orange w-button"><label id="w-node-_0d375efe-3885-1000-a31d-8afe2cc37944-01529649" class="w-checkbox checkbox-field">
            <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"></div><input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox" required="" style="opacity:0;position:absolute;z-index:-1">
            <p class="cookies-font check">By signing up you agree to our <a href="#">Terms &amp; Condition</a>.</p><span class="checkbox-label w-form-label">Checkbox</span>
          </label>
        </form>
        <div class="success-message w-form-done">
          <div>Thank you! Your submission has been received!</div>
        </div>
        <div class="error-message w-form-fail">
          <div>Oops! Something went wrong while submitting the form.</div>
        </div>
      </div>
    </div>
    <div class="or-line">
      <div class="or-block">Or</div>
    </div>
    <div class="social-wrapper no-line">
      <a href="#" class="social-icon w-inline-block"><img src="assets/img/facebook_1facebook.png" width="14" alt=""></a>
      <a href="#" class="social-icon w-inline-block"><img src="assets/img/twitter_1twitter.png" width="14" alt=""></a>
      <a href="#" class="social-icon w-inline-block"><img src="assets/img/instagram_1instagram.png" width="15" alt=""></a>
    </div>
  </div><img src="assets/img/scribbles-7.png" width="120" data-w-id="c4c19508-0136-1eef-f777-8c88277a848d" sizes="100vw" srcset="assets/img/scribbles-7-p-500.png 500w, assets/img/scribbles-7.png 812w" alt="" class="scribble-3 bird">
</div>-->

<div id="overlay" *ngIf="showVideo"></div>
<div class="intro-video" *ngIf="showVideo">
  <button class="close-intro-video" (click)="showVideo = false">
    <i class="material-icons">close</i>
  </button>
  <iframe class="embedly-embed"
          src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2F2_lu0bfwNd0%3Ffeature%3Doembed&display_name=YouTube&url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D2_lu0bfwNd0&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2F2_lu0bfwNd0%2Fhqdefault.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=youtube"
          scrolling="no" title="YouTube embed"
          frameborder="0" allow="autoplay; fullscreen">
  </iframe>
</div>


<!--START: Footer-->
<landing-app-footer></landing-app-footer>
<!--END: Footer-->
